import axios from "axios";
import { buildRequestConfig } from "./buildRequestConfig";

const FILES_API_BASE = `${process.env.REACT_APP_API_HOST}/v1/files`;

class FilesService {
  async getFiles(folderId?: string) {
    const config = await buildRequestConfig();
    const params = folderId ? { folderId } : {};
    const response = await axios.get(`${FILES_API_BASE}/files`, { ...config, params });
    return response.data.data;
  }

  async searchFiles(query: string) {
    const config = await buildRequestConfig();
    const response = await axios.get(`${FILES_API_BASE}/files/search`, {
      ...config,
      params: { q: query },
    });
    return response.data.data;
  }

  async deleteFile(fileId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(`${FILES_API_BASE}/files/${fileId}`, config);
    return response.data.data;
  }

  async createFolder(folderName: string, parentFolderId?: string) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/folders`,
      { folderName, parentFolderId: parentFolderId || "ROOT" },
      config
    );
    return response.data.data;
  }

  async deleteFolder(folderId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(`${FILES_API_BASE}/folders/${folderId}`, config);
    return response.data.data;
  }

  async linkFileToVOD(mediaId: string, fileId: string, title?: string) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/vod/${mediaId}/files`,
      { fileId, title },
      config
    );
    return response.data.data;
  }

  async unlinkFileFromVOD(mediaId: string, fileId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(
      `${FILES_API_BASE}/vod/${mediaId}/files/${fileId}`,
      config
    );
    return response.data.data;
  }

  async addHyperlinkToVOD(mediaId: string, url: string, title: string) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/vod/${mediaId}/links`,
      { url, title },
      config
    );
    return response.data.data;
  }

  async removeHyperlinkFromVOD(mediaId: string, linkId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(
      `${FILES_API_BASE}/vod/${mediaId}/links/${linkId}`,
      config
    );
    return response.data.data;
  }

  async getVODAttachments(mediaId: string) {
    const config = await buildRequestConfig();
    const response = await axios.get(
      `${FILES_API_BASE}/vod/${mediaId}/attachments`,
      config
    );
    return response.data.data;
  }

  async generateShareToken(fileId: string) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/files/${fileId}/share`,
      {},
      config
    );
    return response.data.data;
  }

  async disableFileShare(fileId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(`${FILES_API_BASE}/files/${fileId}/share`, config);
    return response.data.data;
  }

  async generateFolderShareToken(folderId: string) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/folders/${folderId}/share`,
      {},
      config
    );
    return response.data.data;
  }

  async disableFolderShare(folderId: string) {
    const config = await buildRequestConfig();
    const response = await axios.delete(`${FILES_API_BASE}/folders/${folderId}/share`, config);
    return response.data.data;
  }

  async getFileShareInfo(shareToken: string) {
    const response = await axios.get(`${FILES_API_BASE}/share/${shareToken}`);
    return response.data.data;
  }
}

export const filesService = new FilesService();
